import { useTheme } from "@/context/ThemeContext";
import DualPaneView from "../components/DualPaneView";
import { cardDataMap } from "../data";
import ExperienceShell from "../ExperienceShell";

export default function ZiweiExperiencePage() {
  const { effectiveTheme } = useTheme();

  return (
    <ExperienceShell activeId="ziwei" contentKey="ziwei">
      <DualPaneView data={cardDataMap.ziwei} isLight={effectiveTheme === "light"} />
    </ExperienceShell>
  );
}
